import { render } from "./historyDetail.vue?vue&type=template&id=362a0030&scoped=true&ts=true"
import script from "./historyDetail.vue?vue&type=script&lang=ts&config=true"
export * from "./historyDetail.vue?vue&type=script&lang=ts&config=true"

import "./historyDetail.vue?vue&type=style&index=0&id=362a0030&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362a0030"]])

export default __exports__